module.exports = __webpack_public_path__ + "img/16_103.58d54ad1.png";